import { Icon, SearchBolder, TableColumn, TableRow } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import _ from 'lodash';
import HtmlParser from 'html-react-parser';
import ContentConstants from '../../../contentConstants';
import { DistributionType, IColumn, IDistributionContact } from '../../../models';
import { IPersonAttribute } from '../../../models/IPersonAttribute';
import { SurveyStatusType } from '../../../models/SurveyStatusType';
import { WarningModal } from '../../common';

export interface IDistributionContactRowProps {
	surveyId: number;
	audienceId: number;
	distributionContact: IDistributionContact;
	distributionType?: DistributionType;
	columns: IColumn[];
	searchText?: string;
	selected?: boolean;
	selectable?: boolean;
	surveyStatus?: SurveyStatusType;
	onDelete: (surveyId: number, audienceId: number, distributionContactId: number) => any;
	selectDistributionContact: (isSelected: boolean) => any;
}

export interface IDistributionContactRowState {
	isWarningModalOpen: boolean;
}

export class DistributionContactRow extends React.Component<IDistributionContactRowProps, IDistributionContactRowState> {
	constructor(props: IDistributionContactRowProps) {
		super(props);

		this.state = { isWarningModalOpen: false };

		this.getColumn = this.getColumn.bind(this);
		this.deleteContact = this.deleteContact.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.toggleWarningModal = this.toggleWarningModal.bind(this);
	}

	public render() {
		const { columns, distributionType, selectable, selected } = this.props;
		const { isWarningModalOpen } = this.state;

		const deleteParticipantsContentBody =
			distributionType === DistributionType.SingleLink
				? ContentConstants.WARNING_DELETE_PARTICIPANTS_SINGLELINK_BODY
				: ContentConstants.WARNING_DELETE_PARTICIPANTS_BODY;
		return (
			<>
				<TableRow selectable={selectable} selected={selected} onSelectRow={() => this.props.selectDistributionContact(!selected)}>
					{_.map(_.orderBy(columns, ['displayOrder']), this.getColumn)}
				</TableRow>
				{isWarningModalOpen && (
					<WarningModal
						isOpen={this.state.isWarningModalOpen}
						contentHeadline={ContentConstants.WARNING_MODAL_DELETE_HEADLINE}
						contentBody={<>{HtmlParser(deleteParticipantsContentBody.replace('{total}', '1'))}</>}
						secondaryButtonText={ContentConstants.BUTTONS_CANCEL}
						onClose={() => this.toggleWarningModal(false)}
						onSubmit={this.handleSubmit}
					/>
				)}
			</>
		);
	}

	public getColumn(column: IColumn, index: any) {
		const { distributionContact, searchText } = this.props;
		const personAttributes = distributionContact.personAttributes;

		// Display the column with value only if the column is seleceted or checked
		if (column.checked) {
			switch (column.name) {
				case 'employeeId':
					return <TableColumn key={index}>{distributionContact.employeeId}</TableColumn>;
				case 'firstName':
					return (
						<TableColumn key={index}>
							<SearchBolder searchText={searchText} text={distributionContact.firstName} />
						</TableColumn>
					);
				case 'lastName':
					return (
						<TableColumn key={index}>
							<SearchBolder searchText={searchText} text={distributionContact.lastName} />
						</TableColumn>
					);
				case 'emailAddress':
					return (
						<TableColumn key={index}>
							<SearchBolder searchText={searchText} text={distributionContact.emailAddress} />
						</TableColumn>
					);
				case 'surveyCompletionStatus':
					return <TableColumn key={index}>{distributionContact.surveyCompletionStatus}</TableColumn>;
				case 'accessCode':
					return <TableColumn key={index}>{distributionContact.accessCode ?? ''}</TableColumn>;
				case 'actions':
					return (
						<TableColumn key={index}>
							<a onClick={this.deleteContact}>
								<Icon name='delete' key={distributionContact.distributionContactId} />
							</a>
						</TableColumn>
					);
			}

			// This code is to display person attributes values from the distribution contact.
			const personAttribute: IPersonAttribute = _.find(
				personAttributes,
				(attr: IPersonAttribute) => attr.attributeId.toString() === column.name,
			)!;
			return <TableColumn key={index}>{personAttribute ? personAttribute.value : ContentConstants.EMPTY_PLACEHOLDER}</TableColumn>;
		}

		return null;
	}

	public deleteContact = () => {
		const { surveyStatus, onDelete } = this.props;
		if (surveyStatus === SurveyStatusType.Scheduled) {
			this.toggleWarningModal(true);
		} else {
			onDelete(this.props.surveyId, this.props.audienceId, this.props.distributionContact.distributionContactId);
		}
	};

	public handleSubmit() {
		const { onDelete } = this.props;
		onDelete(this.props.surveyId, this.props.audienceId, this.props.distributionContact.distributionContactId);
		this.toggleWarningModal(false);
	}

	public toggleWarningModal(isOpen: boolean) {
		this.setState({ isWarningModalOpen: isOpen });
	}
}
